import { render, staticRenderFns } from "./RightPanelContainerName.vue?vue&type=template&id=3e36ea70&scoped=true&"
import script from "./RightPanelContainerName.vue?vue&type=script&lang=js&"
export * from "./RightPanelContainerName.vue?vue&type=script&lang=js&"
import style0 from "./RightPanelContainerName.vue?vue&type=style&index=0&id=3e36ea70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36ea70",
  null
  
)

export default component.exports